/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProjectTaskRef } from './projectTaskRef';
import { Milestone } from './milestone';
import { CompanyBrandRef } from './companyBrandRef';
import { TeamRef } from './teamRef';
import { Workflow } from './workflow';
import { UserInfo } from './userInfo';
import { ProjectRef } from './projectRef';
import { CompanyRef } from './companyRef';


export interface UpdateTaskDto { 
    name?: string;
    description?: string;
    taskTypeId?: string;
    taskType?: string;
    isOnCriticalPath?: boolean;
    currentlyWith?: string;
    currentStepId?: number;
    lastStepId?: number;
    status?: string;
    taskDuration?: number;
    startDate?: string;
    deadline?: string;
    project?: ProjectRef;
    assets?: Array<string>;
    mainAsset?: string;
    mainAssetId?: string;
    resetMainAssetFlag?: boolean;
    parentProjectId?: string;
    communication?: Array<string>;
    annotationStatus?: Array<string>;
    agency?: CompanyRef;
    client?: CompanyRef;
    brand?: CompanyBrandRef;
    childIds?: Array<ProjectTaskRef>;
    parentId?: ProjectTaskRef;
    workflow?: Workflow;
    currentlyWithUser?: UserInfo;
    currentlyWithTeam?: TeamRef;
    nextDueDate?: string;
    parentStartDate?: string;
    parentDeadline?: string;
    timeZoneOffset?: number;
    parentTaskId?: ProjectTaskRef;
    parentRefIds?: Array<ProjectTaskRef>;
    mileStones?: Array<Milestone>;
}

